import React from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from '../../elements/Title';


const useStyles = makeStyles({
  depositContext: {
    flex: 1,
  },
});

export default function DashboardChargeCounter(props) {
  const classes = useStyles();
  return (
    <>
    <React.Fragment>
      <Title>Emergency Contacts</Title>
      <Typography component="p" variant="h4">
        {props.charges}
      </Typography>
      <Typography color="textSecondary" className={classes.depositContext}>
        last updated {props.lastUpdated}
      </Typography>
      <div>
        <Link color="primary" href="/emergency" >
          View Emergency Contacts
        </Link>
      </div>
    </React.Fragment>
    </>
  );
}